import { FuseUtils } from '@fuse/utils';

export class Infra {
    Id: string;
    Name: string;
    ParentId: string;
    SettingsId: string;
    Checked: boolean;
    Latitude: number;
    Longitude: number;
    ComputerCount: number;
    HomeOffice: number;
    InLoco: number;
    PAs: number;
    Active: number;
    Pending: number;
    SettingsName: string;
    Updated: number;
    Configurated: number;
    

    /**
     * Constructor
     *
     * @param job
     */
    constructor(infra) {
        {
            //            this.Id = job.Id || FuseUtils.generateGUID();
            this.Id = infra.Id || 0;
            this.Name = infra.Name || '';
            this.ParentId = (infra.ParentId) || '';
            this.SettingsId = (infra.SettingsId) || '';
            this.Checked = true;
            this.Latitude = infra.Latitude || 0;
            this.Longitude = infra.Longitude || 0;
            this.ComputerCount = infra.ComputerCount || 0;
            this.HomeOffice = infra.HomeOffice || 0;
            this.InLoco = infra.InLoco || 0;
            this.PAs = infra.PAs || 0;
            this.Active = infra.Active || 0;
            this.Pending = infra.Pending || 0;
            this.SettingsName = infra.SettingsName || "";
            this.Updated = infra.Updated || 0;
            this.Configurated = infra.Configurated || 0;
            
        }
    }
}

export class InfraTree {
    id: string;
    title: string;
    type: string;
    url: string;
    children: InfraTree[];


    /**
     * Constructor
     *
     * @param job
     */
    constructor(infra) {
        {
            this.id = infra.Id || undefined;
            this.title = infra.Name || undefined;
            this.type = infra.Type || 'item';
            this.url = ('/register/infra/' + this.id) || undefined;
            this.children = [];
        }
    }
}
